import React from 'react'

import useBoundState from 'store'
import { ErrorSign, InfoSign } from 'styles/commons'
import { Icons } from 'utils/icons'
import { ErrorIconEnum } from 'enums/ErrorIconEnum'

import { Button } from '@interco/inter-ui/components/Button'
import { Text } from '@interco/inter-ui/components/Text'

import { BtnBack, Container, Content, ErrorContainer } from './ErrorPage.styles'

interface ErrorPageProps {
  title: string | JSX.Element
  subTitle: string | JSX.Element
  nameButton?: string
  disabledButton?: boolean
  disabledHome?: boolean
  errorIcon?: ErrorIconEnum
  goHome: () => void
  done: () => void
}

export const ErrorPage: React.FC<ErrorPageProps> = ({
  title,
  subTitle,
  nameButton,
  disabledButton,
  disabledHome,
  goHome,
  done,
  errorIcon = ErrorIconEnum.ERROR,
}) => {
  const errorIconDictionary: Record<ErrorIconEnum, React.ReactElement> = {
    [ErrorIconEnum.WARNING]: (
      <InfoSign>
        <Icons.Warning width={32} height={32} color="var(--alert500)" />
      </InfoSign>
    ),
    [ErrorIconEnum.ERROR]: (
      <ErrorSign>
        <Icons.Canceled width={32} height={32} color="var(--neutral-theme)" />
      </ErrorSign>
    ),
  }

  const navbarTitle = useBoundState((state) => state.title)
  const homeIcon = <Icons.Home width={24} height={24} color="var(--primary500)" />

  const button = (
    <Button className="foot-button" data-testid="done-button" onClick={done} variant="primary">
      {nameButton || 'Entendi'}
    </Button>
  )

  return (
    <ErrorContainer>
      <Container>
        <BtnBack
          type="button"
          onClick={goHome}
          aria-label="Botão voltar erro"
          data-testid="home-button"
        >
          {!disabledHome && homeIcon}
        </BtnBack>
        <Text variant="headline-h3" as="h3">
          {navbarTitle}
        </Text>
        <Content>
          {errorIconDictionary[errorIcon]}
          <Text variant="headline-h1" as="h1">
            {title}
          </Text>
          <Text variant="body-3">{subTitle}</Text>
        </Content>
        {!disabledButton && button}
      </Container>
    </ErrorContainer>
  )
}
